import { render } from "./changePsd.vue?vue&type=template&id=a8c4cb7c"
import script from "./changePsd.vue?vue&type=script&lang=js"
export * from "./changePsd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__